/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KemConsentForm } from '../models/KemConsentForm';
import type { KemConsentFormPartialExcluding_id_changedGuardianDetails_created_at_ } from '../models/KemConsentFormPartialExcluding_id_changedGuardianDetails_created_at_';
import type { KemConsentFormWithRelations } from '../models/KemConsentFormWithRelations';
import type { NewKemConsentForm } from '../models/NewKemConsentForm';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class KemConsentFormControllerService {

    /**
     * @returns void
     * @throws ApiError
     */
    public static kemConsentFormControllerUpdateById({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: KemConsentFormPartialExcluding_id_changedGuardianDetails_created_at_,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/kem-consent-form/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns KemConsentFormWithRelations KemConsentForm model instance
     * @throws ApiError
     */
    public static kemConsentFormControllerFindById({
        id,
        filter,
    }: {
        id: string,
        filter?: any,
    }): CancelablePromise<KemConsentFormWithRelations> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-consent-form/{id}',
            path: {
                'id': id,
            },
            query: {
                'filter': filter,
            },
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static kemConsentFormControllerDeleteById({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/kem-consent-form/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns KemConsentForm KemConsentForm model instance
     * @throws ApiError
     */
    public static kemConsentFormControllerCreate({
        requestBody,
    }: {
        requestBody?: NewKemConsentForm,
    }): CancelablePromise<KemConsentForm> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kem-consent-form',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any Array of KemConsentForm model instances
     * @throws ApiError
     */
    public static kemConsentFormControllerFindAll({
        filter,
        page,
    }: {
        filter?: any,
        page?: number,
    }): CancelablePromise<{
        currentPage?: number;
        totalPages?: number;
        count?: number;
        status?: string;
        data?: Array<KemConsentFormWithRelations>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-consent-form',
            query: {
                'filter': filter,
                'page': page,
            },
        });
    }

    /**
     * @returns any KemConsentForm model instance
     * @throws ApiError
     */
    public static kemConsentFormControllerResendEmail({
        userId,
    }: {
        userId: string,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-consent-form-resend/{userId}',
            path: {
                'userId': userId,
            },
        });
    }

}
